// Tiny platform helpers for keyboard hint display.

export const isMac = typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent)

/** The modifier key glyph shown in keyboard hints — ⌘ on mac, Ctrl elsewhere. */
export const modKey = isMac ? '⌘' : 'Ctrl'
